import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayButtonComponent } from './pay-button/pay-button.component';

@NgModule({
  declarations: [PayButtonComponent],
  imports: [CommonModule],
  exports: [PayButtonComponent],
})
export class SharedModule {}
